<div class="view-labels-multi-select" [ngClass]="{ 'multiple-rows': multipleRows }">
  <div class="selected-label" *ngFor="let binding of labelBindings">
    <app-view-selected-label
      [labelBinding]="binding"
      [label]="getLabelById(binding.label.id)"
      [canBeRemoved]="canBeRemoved"
      (removeLabelEventEmitter)="clearSingleOption($event)"
    >
    </app-view-selected-label>
    <app-additional-values
      *ngIf="showMergedValues()"
      [additionalValues]="getMergedLabelsDisplayNames()"
      [includePaddingInMinWidth]="true"
    >
    </app-additional-values>
  </div>
</div>
